import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';
import { CaptureConfig } from '@sb/routine-runner/Step/Capture/captureConfig';

export namespace RunLocateSkillStep {
  export const name = 'Locate';
  export const description = 'Locate via vision';
  export const librarySection = Step.LibrarySection.Vision;
  export const argumentKind = 'RunLocateSkill';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    skillId: zod.string().default(''),
    positionListName: zod.string().optional(),
    // Display-only name for the derived capture-pose Space item. Consumed by
    // `getVirtualSpaceItems`; the routine runner never sees Space-item names,
    // so this is intentionally not forwarded through `toRoutineRunner`.
    capturePoseName: zod.string().optional(),
    captureConfig: CaptureConfig.optional(),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    return {
      ...stepData,
      stepKind: 'RunLocateSkill',
      args: {
        skillId: args.skillId,
        positionListName: args.positionListName,
        captureConfig: args.captureConfig,
      },
    };
  };
}

RunLocateSkillStep satisfies Step.StepKindInfo;
